exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#panelCats[data-v-5b9f619c]{height:458px;border:1px solid #00d1b2;background:#fff;overflow-y:scroll}.panel-block[data-v-5b9f619c]{border:1px solid #00d1b2}a.panel-block.itemsCats[data-v-5b9f619c]:hover{background-color:#c7faf2;color:#00d1b2}a.panel-block.itemsCats.is-active[data-v-5b9f619c]{background-color:#00d1b2;color:#fff}.panel-block[data-v-5b9f619c]:first-child,.panel-heading[data-v-5b9f619c]:first-child,.panel-tabs[data-v-5b9f619c]:first-child{border-top:#00d1b2}.panel-block.is-active .panel-icon[data-v-5b9f619c]{color:#fff}span.tag.is-warning.is-medium[data-v-5b9f619c]{margin-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b9f619c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/inventario_Componentes/ListSubCategorias.vue
// module id = 2169
// module chunks = 0